export const FETCH_DIAGNOSTICOS_REQUEST = "FETCH_DIAGNOSTICOS_REQUEST";
export const FETCH_DIAGNOSTICOS_SUCCESS = "FETCH_DIAGNOSTICOS_SUCCESS";
export const FETCH_DIAGNOSTICOS_FAILURE = "FETCH_DIAGNOSTICOS_FAILURE";
export const ADD_DIAGNOSTICO = "ADD_DIAGNOSTICO";
export const REMOVE_DIAGNOSTICO = "REMOVE_DIAGNOSTICO";
export const MARK_DIAGNOSTICO_PLANIFICADO = "MARK_DIAGNOSTICO_PLANIFICADO";
